angular.module('harriApp')
//
//    .directive('ngUploadAction', function() {
//        return {
//            link: function(scope, element, attr) {
//
//
//
//            }
//        }
//    })
    .directive('hUpload', [ '$http', '$timeout', 'Upload', '$q', '$rootScope', function($http, $timeout, Upload, $q, $rootScope) {
        return {
            link: function($scope, element, attr) {
                //files to upload
                $scope.$files = [];

                //specify upload url
                $scope.uploadUrl = attr.ngUploadAction;
                if($scope.uploadUrl && $scope.uploadUrl.indexOf("http") == -1) {
                    $scope.uploadUrl =  publicConfiguration.APIServerBaseURL + $scope.uploadUrl;
                }

                $scope.uploadMethod = attr.ngUploadMethod || "PUT";

                $scope.fileReaderSupported = window.FileReader != null && (window.FileAPI == null || FileAPI.html5 != false);
                $scope.uploadRightAway = false;

//                //should be changed by the type of operation
//                $scope.uploadDefault = function() {
//                    $scope.directUpload($scope.$files, $scope.uploadUrl, $scope.uploadMethod, {brand_id:93}).then(function(response) {
////                        console.log("uploaded", response);
//                    })
//                };


                //should be changes based on the type of selection
                $scope.onFileSelect = function ($files) {

                    if($files.length){
                      $rootScope.$broadcast('showImageCroppingModalLoading');
                    }

                    $scope.$files = [];
                    //add files to queue
                    for (var i = 0; i < $files.length; i++) {
                        $scope.$files.push($files[i]);
                    }

                    var opt = {
                        file: $files? $files[0]: null,
                        croppingModalCallBack:function (coords, image) {
                            $scope.loadImageWithFileReader($files).then(function(images) {
                                if(images && images.length > 0) {
                                    $scope.$croppedImage = images[0];
                                    $scope.$coords = coords;
                                }
                            });
                        }
                    };

                    // send selected files && show modal
                    $rootScope.$broadcast('showImageCroppingModal', opt);

//                    //set image binary to $image variable

                };

                $scope.directUpload = function($files, uploadUrl, uploadMethod, data, progress, done) {
                    if(!data) {
                        data = {};
                    }

                    if(uploadUrl && uploadUrl.indexOf("http") == -1) {
                        uploadUrl =  publicConfiguration.APIServerBaseURL + uploadUrl;
                    }

                    if(!uploadUrl) {
                        uploadUrl = $scope.uploadUrl;
                    }

                    if(!uploadMethod) {
                        uploadMethod = $scope.uploadMethod;
                    }

                    var defer = $q.defer();
                    var results = [];

                    if($files.length === 0) {
                        defer.resolve(results);
                    } else {
                        uploadNext();
                    }

                    function uploadNext() {
                        if($files.length === 0) {
                            defer.resolve(results);
                            return;
                        }

                        var file = $files.pop();

                        if (!Utils.checkFileSize(file)) {
                          if (done) done();
                          uploadNext();
                          return;
                        }

                        var promise = $scope.upload = Upload.upload({
                            url: uploadUrl,
                            withCredentials: true,
                            headers: {},
                            method: uploadMethod,
                            data: data,
                            file: file
                        }).progress(function (evt) {
                            var p = parseInt(100.0 * evt.loaded / evt.total);
                            if(progress) {
                                progress(file, p);
                            }
//                            console.log('percent: ' + parseInt(100.0 * evt.loaded / evt.total));
                        }).success(function (data, status, headers, config) {
                        }).error(function (reason) {
                        });

                        promise.then(function(d) {
                            if(done) {
                                done(d);
                            }
                            results.push(d);
                            uploadNext();
                        }, function() {
                            uploadNext();
                        })
                    }

                    return defer.promise;
                };

                //read the first file
                $scope.loadImageWithFileReader = function($files) {
                    var promises = [];

                    $scope.upload = [];
                    $scope.uploadResult = [];
                    $scope.selectedFiles = $files;
                    $scope.dataUrls = [];

                    for (var i = 0; i < $files.length; i++) {
                        var $file = $files[i];
                        if ($scope.fileReaderSupported && $file.type.indexOf('image') > -1) {

                            var fileReader = new FileReader();
                            fileReader.readAsDataURL($files[i]);
                            var loadFile = function (fileReader, index) {
                                var defer = $q.defer();

                                fileReader.onload = function (e) {
                                    $timeout(function () {
                                        $scope.dataUrls[index] = e.target.result;
                                        defer.resolve(e.target.result);
                                        //break;
//                                        $scope.$image = e.target.result;
                                    });
                                };

                                promises.push(defer.promise);
                            }(fileReader, i);
                        }
                    }

                    return $q.all(promises);
                };

                $scope.dragOverClass = function($event) {
                    var items = $event.dataTransfer.items;
                    var hasFile = false;
                    if (items != null) {
                        for (var i = 0 ; i < items.length; i++) {
                            if (items[i].kind == 'file') {
                                hasFile = true;
                                break;
                            }
                        }
                    } else {
                        hasFile = true;
                    }
                    return hasFile ? "dragover" : "dragover-err";
                };
            }
        }
    }]);

//.controller('uploadCtrl', [ '$scope', '$http', '$timeout', 'Upload', function($scope, $http, $timeout, Upload) {
//
//        $scope.fileReaderSupported = window.FileReader != null && (window.FileAPI == null || FileAPI.html5 != false);
//        $scope.uploadRightAway = false;
//
//
//        $scope.onFileSelect = function ($files) {
//            for (var i = 0; i < $files.length; i++) {
//                var file = $files[i];
//
//                $scope.upload = Upload.upload({
//                    url: $scope.uploadUrl,
//                    withCredentials: true,
//                    headers: {},
//                    method: 'PUT',
//                    data: {brand_id: 93},
//                    file: file
//                }).progress(function (evt) {
//                    console.log('percent: ' + parseInt(100.0 * evt.loaded / evt.total));
//                }).success(function (data, status, headers, config) {
//                    // file is uploaded successfully
//                    console.log(data);
//                }).error(function () {
//
//                })
//                //.then(success, error, progress);
//                // access or attach event listeners to the underlying XMLHttpRequest.
//                //.xhr(function(xhr){xhr.upload.addEventListener(...)})
//            }
//        };
//
//        $scope.loadImageWithFileReader = function($files) {
//            $scope.upload = [];
//            $scope.uploadResult = [];
//            $scope.selectedFiles = $files;
//            $scope.dataUrls = [];
//            for (var i = 0; i < $files.length; i++) {
//                var $file = $files[i];
//                if ($scope.fileReaderSupported && $file.type.indexOf('image') > -1) {
//                    var fileReader = new FileReader();
//                    fileReader.readAsDataURL($files[i]);
//                    var loadFile = function (fileReader, index) {
//                        fileReader.onload = function (e) {
//                            $timeout(function () {
//                                $scope.dataUrls[index] = e.target.result;
//                                $scope.$parent.company_icon = e.target.result;
//                            });
//                        }
//                    }(fileReader, i);
//                }
//            }
//        }
//
//        $scope.dragOverClass = function($event) {
//            var items = $event.dataTransfer.items;
//            var hasFile = false;
//            if (items != null) {
//                for (var i = 0 ; i < items.length; i++) {
//                    if (items[i].kind == 'file') {
//                        hasFile = true;
//                        break;
//                    }
//                }
//            } else {
//                hasFile = true;
//            }
//            return hasFile ? "dragover" : "dragover-err";
//        };
//
//    }]);
//



//        return;
//
//        $scope.selectedFiles = [];
//        $scope.progress = [];
//        if ($scope.upload && $scope.upload.length > 0) {
//            for (var i = 0; i < $scope.upload.length; i++) {
//                if ($scope.upload[i] != null) {
//                    $scope.upload[i].abort();
//                }
//            }
//        }
//        $scope.upload = [];
//        $scope.uploadResult = [];
//        $scope.selectedFiles = $files;
//        $scope.dataUrls = [];
//        for ( var i = 0; i < $files.length; i++) {
//            var $file = $files[i];
//            if ($scope.fileReaderSupported && $file.type.indexOf('image') > -1) {
//                var fileReader = new FileReader();
//                fileReader.readAsDataURL($files[i]);
//                var loadFile = function(fileReader, index) {
//                    fileReader.onload = function(e) {
//                        $timeout(function() {
//                            $scope.dataUrls[index] = e.target.result;
//
//                            $scope.$parent.company_icon = e.target.result;
//
//
//                        });
//                    }
//                }(fileReader, i);
//            }
//            $scope.progress[i] = -1;
//            if ($scope.uploadRightAway) {
//                $scope.start(i);
//            }
//        }
//    };

//    $scope.start = function(index) {
//        $scope.progress[index] = 0;
//        $scope.errorMsg = null;
//        //@TODO fix
//        if (false && $scope.howToSend == 1) {
//            $scope.upload[index] = Upload.upload({
//                url: uploadUrl,
//                method: 'POST',//$scope.httpMethod,
//                headers: {
//                    'my-header': 'my-header-value',
//                    withCredentials:true,
//                    method:'POST'
//
//                },
//                data : {
//                    brand_id:1,
//                    myModel : $scope.myModel
//                },
//                formData: [
//                    {
//                        key: 'value',
//                        izena:''
//                    }
//                ],
//                /* formDataAppender: function(fd, key, val) {
//                 if (angular.isArray(val)) {
//                 angular.forEach(val, function(v) {
//                 fd.append(key, v);
//                 });
//                 } else {
//                 fd.append(key, val);
//                 }
//                 }, */
//                /* transformRequest: [function(val, h) {
//                 console.log(val, h('my-header')); return val + '-modified';
//                 }], */
//                file: $scope.selectedFiles[index],
//                fileFormDataName: 'myFile'
//            });
//            $scope.upload[index].then(function(response) {
//                $timeout(function() {
//                    $scope.uploadResult.push(response.data);
//                });
//            }, function(response) {
//                if (response.status > 0) $scope.errorMsg = response.status + ': ' + response.data;
//            }, function(evt) {
//                // Math.min is to fix IE which reports 200% sometimes
//                $scope.progress[index] = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
//            });
//            $scope.upload[index].xhr(function(xhr){
////				xhr.upload.addEventListener('abort', function() {console.log('abort complete')}, false);
//            });
//        } else {
//            var fileReader = new FileReader();
//            fileReader.onload = function(e) {
//                $scope.upload[index] = Upload.http({
//                    url: uploadUrl,
//                    headers: {'Content-Type': $scope.selectedFiles[index].type},
//                    data: e.target.result
//                }).then(function(response) {
//                    $scope.uploadResult.push(response.data);
//                }, function(response) {
//                    if (response.status > 0) $scope.errorMsg = response.status + ': ' + response.data;
//                }, function(evt) {
//                    // Math.min is to fix IE which reports 200% sometimes
//                    $scope.progress[index] = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
//                });
//            }
//            fileReader.readAsArrayBuffer($scope.selectedFiles[index]);
//        }
//    };
//
//    $scope.dragOverClass = function($event) {
//        var items = $event.dataTransfer.items;
//        var hasFile = false;
//        if (items != null) {
//            for (var i = 0 ; i < items.length; i++) {
//                if (items[i].kind == 'file') {
//                    hasFile = true;
//                    break;
//                }
//            }
//        } else {
//            hasFile = true;
//        }
//        return hasFile ? "dragover" : "dragover-err";
//    };
//} ]);


//var uploadUrl = 'http://backend.harri.com/api/v1/brand_gallery_photo';//'http://localhost:8888/h3.php';
////var uploadUrl = 'http://localhost:8888/h3.php';
////inject angular file upload directives and service.
//angular.module('formsModule').controller('uploadCtrl', [ '$scope', '$http', '$timeout', 'Upload', function($scope, $http, $timeout, Upload) {
//    $scope.usingFlash = false; //FileAPI && FileAPI.upload != null;
//    $scope.fileReaderSupported = window.FileReader != null && (window.FileAPI == null || FileAPI.html5 != false);
//    $scope.uploadRightAway = true;
//    $scope.changeAngularVersion = function() {
//        window.location.hash = $scope.angularVersion;
//        window.location.reload(true);
//    };
//    $scope.hasUploader = function(index) {
//        return $scope.upload[index] != null;
//    };
//    $scope.abort = function(index) {
//        $scope.upload[index].abort();
//        $scope.upload[index] = null;
//    };
//    $scope.angularVersion = window.location.hash.length > 1 ? (window.location.hash.indexOf('/') === 1 ?
//        window.location.hash.substring(2): window.location.hash.substring(1)) : '1.2.20';
//    $scope.onFileSelect = function($files) {
//
//        for (var i = 0; i < $files.length; i++) {
//            var file = $files[i];
//            $scope.upload = Upload.upload({
//                url: uploadUrl,
//                withCredentials: true,
//                headers: {
////                    withCredentials:true,
////                    enctype: "multipart/form-data"
//                },
//                method:'PUT',
//                //method: 'POST' or 'PUT',
//                //headers: {'header-key': 'header-value'},
//                //withCredentials: true,
//                data: {brand_id:"1"},
//                file: file // or list of files ($files) for html5 only
//                //fileName: 'doc.jpg' or ['1.jpg', '2.jpg', ...] // to modify the name of the file(s)
//                // customize file formData name ('Content-Disposition'), server side file variable name.
//                //fileFormDataName: myFile, //or a list of names for multiple files (html5). Default is 'file'
//                // customize how data is added to formData. See #40#issuecomment-28612000 for sample code
//                //formDataAppender: function(formData, key, val){}
//            }).progress(function (evt) {
//                console.log('percent: ' + parseInt(100.0 * evt.loaded / evt.total));
//            }).success(function (data, status, headers, config) {
//                // file is uploaded successfully
//                console.log(data);
//            });
//            //.error(...)
//            //.then(success, error, progress);
//            // access or attach event listeners to the underlying XMLHttpRequest.
//            //.xhr(function(xhr){xhr.upload.addEventListener(...)})
//        }
//
//        return;
//
//        $scope.selectedFiles = [];
//        $scope.progress = [];
//        if ($scope.upload && $scope.upload.length > 0) {
//            for (var i = 0; i < $scope.upload.length; i++) {
//                if ($scope.upload[i] != null) {
//                    $scope.upload[i].abort();
//                }
//            }
//        }
//        $scope.upload = [];
//        $scope.uploadResult = [];
//        $scope.selectedFiles = $files;
//        $scope.dataUrls = [];
//        for ( var i = 0; i < $files.length; i++) {
//            var $file = $files[i];
//            if ($scope.fileReaderSupported && $file.type.indexOf('image') > -1) {
//                var fileReader = new FileReader();
//                fileReader.readAsDataURL($files[i]);
//                var loadFile = function(fileReader, index) {
//                    fileReader.onload = function(e) {
//                        $timeout(function() {
//                            $scope.dataUrls[index] = e.target.result;
//
//                            $scope.$parent.company_icon = e.target.result;
//
//
//                        });
//                    }
//                }(fileReader, i);
//            }
//            $scope.progress[i] = -1;
//            if ($scope.uploadRightAway) {
//                $scope.start(i);
//            }
//        }
//    };
//
//    $scope.start = function(index) {
//        $scope.progress[index] = 0;
//        $scope.errorMsg = null;
//        //@TODO fix
//        if (false && $scope.howToSend == 1) {
//            $scope.upload[index] = Upload.upload({
//                url: uploadUrl,
//                method: 'POST',//$scope.httpMethod,
//                headers: {
//                    'my-header': 'my-header-value',
//                    withCredentials:true,
//                    method:'POST'
//
//                },
//                data : {
//                    brand_id:1,
//                    myModel : $scope.myModel
//                },
//                formData: [
//                    {
//                        key: 'value',
//                        izena:''
//                    }
//                ],
//                /* formDataAppender: function(fd, key, val) {
//                 if (angular.isArray(val)) {
//                 angular.forEach(val, function(v) {
//                 fd.append(key, v);
//                 });
//                 } else {
//                 fd.append(key, val);
//                 }
//                 }, */
//                /* transformRequest: [function(val, h) {
//                 console.log(val, h('my-header')); return val + '-modified';
//                 }], */
//                file: $scope.selectedFiles[index],
//                fileFormDataName: 'myFile'
//            });
//            $scope.upload[index].then(function(response) {
//                $timeout(function() {
//                    $scope.uploadResult.push(response.data);
//                });
//            }, function(response) {
//                if (response.status > 0) $scope.errorMsg = response.status + ': ' + response.data;
//            }, function(evt) {
//                // Math.min is to fix IE which reports 200% sometimes
//                $scope.progress[index] = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
//            });
//            $scope.upload[index].xhr(function(xhr){
////				xhr.upload.addEventListener('abort', function() {console.log('abort complete')}, false);
//            });
//        } else {
//            var fileReader = new FileReader();
//            fileReader.onload = function(e) {
//                $scope.upload[index] = Upload.http({
//                    url: uploadUrl,
//                    headers: {'Content-Type': $scope.selectedFiles[index].type},
//                    data: e.target.result
//                }).then(function(response) {
//                    $scope.uploadResult.push(response.data);
//                }, function(response) {
//                    if (response.status > 0) $scope.errorMsg = response.status + ': ' + response.data;
//                }, function(evt) {
//                    // Math.min is to fix IE which reports 200% sometimes
//                    $scope.progress[index] = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
//                });
//            }
//            fileReader.readAsArrayBuffer($scope.selectedFiles[index]);
//        }
//    };
//
//    $scope.dragOverClass = function($event) {
//        var items = $event.dataTransfer.items;
//        var hasFile = false;
//        if (items != null) {
//            for (var i = 0 ; i < items.length; i++) {
//                if (items[i].kind == 'file') {
//                    hasFile = true;
//                    break;
//                }
//            }
//        } else {
//            hasFile = true;
//        }
//        return hasFile ? "dragover" : "dragover-err";
//    };
//} ]);
